import { render, staticRenderFns } from "./DeliveryDealsDebts.vue?vue&type=template&id=37582665&"
import script from "./DeliveryDealsDebts.vue?vue&type=script&lang=js&"
export * from "./DeliveryDealsDebts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports